export { default as FormattedMessageWithTags } from './FormattedMessageWithTags'
